import * as JspUtil from './JspUtil';
import * as constants from './constants';

// ─── Capture all JSP globals once at module load ───────────────────────────────
// These are set by the JSP server in index.html before React boots.
// After this snapshot, React code never reads window.jsp* globals directly.

const readGlobal = (name) =>
    typeof window[name] !== 'undefined' && JspUtil.isValueAvailable(window[name])
        ? window[name]
        : '';

export const jspGlobals = Object.freeze({
    jspCsrfToken: readGlobal('jspCsrfToken'),
    jspAccessToken: readGlobal('jspAccessToken'),
    jspCloseOnSuccess: readGlobal('jspCloseOnSuccess'),
    jspRedirectUrl: readGlobal('jspRedirectUrl'),
    jspCode: readGlobal('jspCode'),
    jspUserId: readGlobal('jspUserId'),
    jspLoggedInAs: readGlobal('jspLoggedInAs'),
    jspApp: readGlobal('jspApp'),
    jspLoginApp: readGlobal('jspLoginApp'),
    jspPasswordUrl: readGlobal('jspPasswordUrl'),
    jspLdapDomains: readGlobal('jspLdapDomains'),
    jspIsVirtualLoginApp: readGlobal('jspIsVirtualLoginApp'),
    jspIceSsoGid: readGlobal('jspIceSsoGid'),
    jspPage: readGlobal('jspPage'),
    jspLinkCandidates: readGlobal('jspLinkCandidates'),
    jspPwd: readGlobal('jspPwd'),
    jspOtpCode: readGlobal('jspOtpCode'),
    jspPasswordLessEnabled: readGlobal('jspPasswordLessEnabled'),
    jspPasswordLessPreferred: readGlobal('jspPasswordLessPreferred'),
    jspIsAppUserRelogin: readGlobal('jspIsAppUserRelogin'),
    jspLoginHint: readGlobal('jspLoginHint'),
    jspDisplayPasswordField: readGlobal('jspDisplayPasswordField'),
    jspBackToApplicationEnabled: readGlobal('jspBackToApplicationEnabled'),
    jspMemberLogin: readGlobal('jspMemberLogin'),
    jspSamlLogin: readGlobal('jspSamlLogin'),
    jspData: readGlobal('jspData'),
    jspUseStoredTemp: readGlobal('jspUseStoredTemp'),
    jspSessions: readGlobal('jspSessions'),
    jspSelectedUser: readGlobal('jspSelectedUser'),
    jspDisableCaptcha: readGlobal('jspDisableCaptcha'),
    jspRefererDomain: readGlobal('jspRefererDomain'),
    jspNyseConnectUrl: readGlobal('jspNyseConnectUrl'),
    jspNyseListingMgrEmail: readGlobal('jspNyseListingMgrEmail'),
    jspNyseDsdAppKey: readGlobal('jspNyseDsdAppKey')
});

// ─── Route map: jspPage value → React route ───────────────────────────────────
const JSP_PAGE_ROUTE_MAP = {
    'NOT_AUTHORIZED': constants.ROUTE_PAGE_NOT_AUTHORIZED,
    'USER_HAS_EXISTING_SESSIONS': constants.ROUTE_PAGE_USER_HAS_EXISTING_SESSIONS,
    'PAGE_MULTIPLE_SESSIONS': constants.ROUTE_PAGE_USER_HAS_EXISTING_SESSIONS,
    'MAX_SESSIONS_EXCEED': constants.ROUTE_PAGE_MAX_SESSIONS_EXCEED,
    'EULA_DOC': constants.ROUTE_PAGE_EULA,
    'WEB_LOGIN': constants.ROUTE_PAGE_WEB_LOGIN,
    'LOGOUT_CHOOSE_LINK': constants.ROUTE_PAGE_LOGOUT,
    'MEMBER_APPS': constants.ROUTE_PAGE_USERINFO,
    'CHANGE_PASSWORD': constants.ROUTE_PAGE_CHANGE_PASSWORD,
    'FORGOT_PASSWORD': constants.ROUTE_PAGE_FORGOT_PASSWORD,
    'REGISTER_GID': constants.ROUTE_PAGE_REQUEST_GLOBAL_ID,
    'REGISTER_GID_WITH_COMPANY': constants.ROUTE_PAGE_REGISTER_GLOBAL_ID_WITH_COMPANY,
    'CONFIRM_USER_EMAIL': constants.ROUTE_PAGE_CONFIRM_USER_EMAIL,
    'SHOW_SAML_MSG': constants.ROUTE_PAGE_SAML_MESSAGE,
    'SHOW_WSFED_MSG': constants.ROUTE_PAGE_WSFED_MESSAGE,
    'SAML_TFA': constants.ROUTE_PAGE_SAML_TFA,
    'CHOOSE_SAML_APP': constants.ROUTE_PAGE_SAML_CHOOSE_APP,
    'APP_USER_LOGIN_TFA': constants.ROUTE_PAGE_APP_USER_LOGIN_TFA,
};

// ─── Compute initial route (called once before React renders) ──────────────────
export function getInitialRoute() {
    if (jspGlobals.jspMemberLogin) {
        return constants.ROUTE_PAGE_MEMBER_LOGIN;
    }
    if (jspGlobals.jspPage && jspGlobals.jspPage !== 'LOGIN') {
        if (jspGlobals.jspPage === 'CHOOSE_LINK' && jspGlobals.jspSamlLogin.trim() !== '') {
            return constants.ROUTE_PAGE_AUTHENTICATED;
        }
        return JSP_PAGE_ROUTE_MAP[jspGlobals.jspPage] || null;
    }
    return null;
}
